module.exports = __webpack_public_path__ + "static/media/details-white.865e6698.svg";